import http from 'plugins/axios'

export default {
  page(data) {
    return http.get({
      url: '/ta/admin/tenant/ios-limit/page',
      data,
    })
  },
  detail(id) {
    return http.get({
      url: `/ta/admin/tenant/ios-limit/detail?id=${encodeURIComponent(id)}`,
    })
  },
  itemOptions() {
    return http.get({
      url: '/ta/admin/tenant/ios-limit/item-options',
    })
  },
  areaOptions() {
    return http.get({
      url: '/ta/admin/tenant/ios-limit/area-options',
    })
  },
  save(data) {
    return http.post({
      url: '/ta/admin/tenant/ios-limit/save',
      data,
    })
  },
  update(data) {
    return http.post({
      url: '/ta/admin/tenant/ios-limit/update',
      data,
    })
  },
  switchEnabled(id, enabled) {
    return http.post({
      url: `/ta/admin/tenant/ios-limit/switch?id=${encodeURIComponent(id)}&enabled=${encodeURIComponent(enabled)}`,
    })
  },
  remove(id) {
    return http.post({
      url: `/ta/admin/tenant/ios-limit/delete?id=${encodeURIComponent(id)}`,
    })
  },
}
